'use client';

import { useGoogleAnalytics } from '@/lib/analytics';

/**
 * GoogleAnalytics component for initializing GA4 tracking
 * Must be wrapped in Suspense boundary in layout
 */
export default function GoogleAnalytics() {
  useGoogleAnalytics();
  return null;
}